import React from "react";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

interface Props {
  label: string;
  value: number | string;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

const RadioSelect: React.FC<Props> = (props) => {
  const { label, value, onChange, disabled } = props;

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    onChange(value === "true");
  };

  return (
    <FormControl
      disabled={disabled}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <FormLabel>{label}</FormLabel>
      <RadioGroup row value={value} onChange={handleChange}>
        <FormControlLabel
          value={true || null}
          control={<Radio />}
          label={"Yes"}
        />
        <FormControlLabel
          value={false || null}
          control={<Radio />}
          label={"No"}
        />
      </RadioGroup>
    </FormControl>
  );
};

export default RadioSelect;
